export const breakpoints = {
  0: 0,
  768: 768,
  992: 992,
  1280: 1280,
  1920: 1920
};
